import React from "react";
import './Loading.scss'
import {animationData} from "./Loading/loadingAnimationData";
import Lottie from "react-lottie";
import LoadingOverlay from "react-loading-overlay";

function Loading(props) {
	const {loading, children} = props;

	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: animationData,
		rendererSettings: {
			preserveAspectRatio: 'xMidYMid slice'
		}

	};
	return (

		//plain loading
		<div style={{
			width: '100%',
			height: '100vh',
			overflowY: loading ? 'hidden' : 'auto',
			overflowX:"hidden",
			zIndex: 1500,
			position: "relative"
		}}>

			{loading &&
			<div style={{width: '100%', height: '100vh', zIndex: 1500, position: "absolute"}}/>
			}
			<div style={{zIndex: 1450}}>
				{children}
			</div>
		</div>

		// loader overlay -------->
		// <LoadingOverlay
		// 	active={loading}
		// 	spinner
		// 	text='Loading...'
		// 	styles={{
		// 		wrapper: {
		// 			width: '100%',
		// 			height: '100vh',
		// 			overflow: loading ? 'hidden' : 'scroll',
		// 			zIndex:1500
		// 		}
		// 	}}
		// 	classNamePrefix='MyLoader_'
		// >
		// 	{children}
		// </LoadingOverlay>

	)

	// loader json -------->
	// 	<>
	// 	<div className={loading ? "loader-component-true" : "loader-component-false"}>
	// 		{
	// 			loading ?
	// 				<>
	// 					<p className={"loader-title"}>NETA</p>
	// 					<div className={"loading-asset"}>
	// 						<Lottie options={defaultOptions} width={"100%"} height={"239px"}/>
	// 					</div>
	//
	// 				</>
	//
	//
	// 				:
	// 				<>
	// 					{children}
	// 				</>
	// 		}
	// 	</div>
	// 		</>
	// );
}

export default Loading;